// 浅色
import { createLightTheme } from './components/create'
import { headerLightTheme } from './components/header'
import { homeLightTheme } from './components/home'
import { settingsLightTheme } from './components/settings'
import { createCollectionLightTheme } from './components/createCollection'
import { detailLightTheme } from './components/detail'
import { marketLightTheme } from './components/market'
import { searchResultLightTheme } from './components/searchResult'
import { mysteryLightTheme } from './components/mystery'
import { mysteryDetailLightTheme } from './components/mysteryDetail'
import { myCollectionsLightTheme } from './components/myCollections'
import { collectionsLightTheme } from './components/collections'
import { myNftsLightTheme } from './components/myNfts'
import { sellLightTheme } from './components/sell'
import { whitePaperLightTheme } from './components/whitePaper'
import { globalLightTheme } from './components/global'

const lightTheme = {
  '--main-bgc-1': '#fff',
  '--main-font-c': '#333',
  '--global-skeleton-loading-bgc-c':
    'linear-gradient(90deg,rgba(190,190,190,.2) 25%,rgba(129,129,129,.24) 37%,rgba(190,190,190,.2) 63%)',
  '--modal-bgc-1': '#fff',
  '--modal-font-c-1': '#333',
  '--modal-border-c-1': '#eee',

  '--trade-modal-bgc-1': '#ffab65',
  '--trade-modal-font-c-1': '#333',
  '--trade-modal-font-c-2': '#41cc8b',

  '--global-payments-bgc-1': '#65D5FF',
  '--global-payments-font-c-1': '#333',
  '--global-payments-font-c-2': '#fff',
  '--global-payments-border-c-1': '#65d5ff',

  '--cust-notification-bgc-1': '#f8f8f8',
  '--cust-notification-font-c-1': '#333',

  '--language-bgc-1': '#f8f8f8',
  '--language-font-c-1': '#333',
  '--language-font-c-2': '#999',
  '--language-font-c-3': '#333',
  '--language-shadow-c-1': 'rgba(0, 0, 0, 0.58)',
  '--language-border-c-1': 'rgba(0, 0, 0, 0.19)',

  '--select-bgc-1': '#f8f8f8',
  '--select-bgc-2': '#f8f8f8',
  '--select-bgc-3': '#fff',
  '--select-bgc-4': '#eee',
  '--select-font-c-1': '#333',
  '--select-border-c-1': '#3b3e49',
  '--input-bgc-1': '#f8f8f8',
  '--input-font-c-1': '#999',
  '--search-bgc-1': '#f8f8f8',
  '--search-font-c-1': '#333',
  '--search-font-c-2': '#9fa7b3',
  '--inftFooter-bgc-1': '#f8f8f8',
  '--inftFooter-font-c-1': '#333',
  '--inftFooter-font-c-2': '#999',
  '--theme-font-c-1': '#333',

  '--card-message-bgc-1': '#f8f8f8',
  '--card-message-bgc-2': 'rgba(27, 22, 50, 0.39)',
  '--card-message-bgc-3': '#fff',
  '--card-message-font-c-1': '#f8f8f8',
  '--card-message-font-c-2': '#666',
  '--card-message-font-c-3': '#666',
  '--card-message-font-c-4': '#fb3225',
  '--card-message-font-c-5': '#333',
  '--card-message-border-c-1': '#3b3e49',
  '--card-message-shadow-c-1': 'rgb(4, 17, 29, 0.25)',
  '--card-message-shadow-c-2': 'rgba(5,5,5,0.09)',

  '--filter-bgc-1': '#f8f8f8',
  '--filter-bgc-2': '#f8f8f8',
  '--filter-bgc-3': '#fff',
  '--filter-bgc-4': '#fff',
  '--filter-bgc-5': '#eee',
  '--filter-font-c-1': '#333',
  '--filter-font-c-2': '#65d5ff',
  '--filter-font-c-3': '#f75b3d',
  '--filter-border-c-1': '#eee',
  '--filter-border-c-2': '#999',
  '--filter-border-c-3': '#65d5ff',

  '--collection-bgc-1': '#f8f8f8',
  '--collection-bgc-2': '#f8f8f8',
  '--collection-bgc-3': '#fff',
  '--collection-bgc-4': 'linear-gradient(90deg, #65d5ff, #5c8dff)',
  '--collection-bgc-5': '#eee',
  '--collection-bgc-6': '#f8f8f8',
  '--collection-font-c-1': '#333',
  '--collection-font-c-2': '#65d5ff',
  '--collection-font-c-3': '#fff',
  '--collection-font-c-4': '#999',
  '--collection-border-c-1': '#3b3e49',

  '--button-bgc-1': 'linear-gradient(341deg, #5c8dff 9%, #65d5ff 83%)',
  '--button-bgc-2': 'linear-gradient(341deg, #0989e5 9%, #37dffd 83%)',
  '--button-font-c-1': '#fff',
  '--button-font-c-2': '#65d5ff',
  '--button-border-c-1': '#65d5ff',
  '--describe-bgc-1': '#fff',
  '--banner-portrait-skeletion-border-c-1': '#141417',

  '--inft-Share-bgc-1': '#f8f8f8',
  '--inft-Share-bgc-2': '#eee',
  '--inft-Share-font-c-1': '#23262f',
  '--inft-Share-font-c-2': '#65d5ff',
  '--inft-Share-font-c-3': '#9fa7b3',
  '--inft-Share-font-c-4': '#666',
  '--inft-Share-border-c-1': '#23262f',
  '--inft-Share-shadow-c-1': '#eee',

  ...createLightTheme,
  ...headerLightTheme,
  ...homeLightTheme,
  ...settingsLightTheme,
  ...createCollectionLightTheme,
  ...detailLightTheme,
  ...marketLightTheme,
  ...searchResultLightTheme,
  ...mysteryLightTheme,
  ...mysteryDetailLightTheme,
  ...myCollectionsLightTheme,
  ...collectionsLightTheme,
  ...myNftsLightTheme,
  ...sellLightTheme,
  ...whitePaperLightTheme,
  ...globalLightTheme,
}

export default lightTheme
